exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-tab-bar.navigation{position:fixed;bottom:0;left:0;z-index:1000;width:100%;background:#fff}.cube-tab-bar.navigation .cube-tab div{font-size:.48rem;padding-top:.08rem}", ""]);

// exports
